import { render, staticRenderFns } from "./AtletaEdit.vue?vue&type=template&id=7b00f633"
import script from "./AtletaEdit.vue?vue&type=script&lang=js"
export * from "./AtletaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports